'use client';

import { useSyncExternalStore } from 'react';
import {
  SCHEMES,
  SCHEME_LABELS,
  type Scheme,
  getScheme,
  getServerSchemeSnapshot,
  setScheme,
  subscribeScheme,
} from '@/lib/theme';

/**
 * Light / Dark / Auto segmented control. DESIGN.md §3.4.1.
 *
 * Independent of the palette — `Auto` clears the manual override so the
 * OS preference takes back over.
 */
export function ColorSchemeToggle() {
  const scheme = useSyncExternalStore(
    subscribeScheme,
    getScheme,
    getServerSchemeSnapshot,
  );

  return (
    <div
      role="radiogroup"
      aria-label="Color scheme"
      className="inline-flex rounded-full bg-sunken p-1"
    >
      {SCHEMES.map((s) => {
        const active = scheme === s;
        return (
          <button
            key={s}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setScheme(s as Scheme)}
            className={
              'pressable rounded-full px-4 py-1.5 text-sm font-medium transition-shadow ' +
              (active
                ? 'bg-raised text-fg-primary shadow-sm'
                : 'text-fg-muted hover:text-fg-primary')
            }
          >
            {SCHEME_LABELS[s as Scheme]}
          </button>
        );
      })}
    </div>
  );
}
